import HttpService from './HttpService';
const API_ENDPOINT = '/city'

const CityService = {
async getStateCities(stateId,countryId) {
        try {
          const response = await HttpService.get(`/city-get/${stateId}/${countryId}`);
          return response.data;
        } catch (error) {
          throw error;
        }
},
async getCities() {
  try {
    const response = await HttpService.get(`${API_ENDPOINT}`);
    return response.data;
  } catch (error) {
    throw error;
  }
},
async getCitiesPaginated(pageConfig) {
  const pageConfigParams =  new URLSearchParams(pageConfig);
  try {
    const response = await HttpService.get(`${API_ENDPOINT}-paginated?${pageConfigParams}`);
    return response.data;
  } catch (error) {
    throw error;
  }
},
async addCity(data) {
  try {
     const response = await HttpService.post(API_ENDPOINT, data);
     return response.data;
  } catch (error) {
      throw error;
  }
},
async updateCity(cityId, data) {
try {
    const response = await HttpService.put(`${API_ENDPOINT}/${cityId}`, data);
    return response.data;
} catch (error) {
    throw error;
}
},
async deleteCity(cityId) {
try {
    const response = await HttpService.delete(`${API_ENDPOINT}/${cityId}`);
    return response.data;
} catch (error) {
    throw error;
}
}
};

export default CityService;